import { params } from 'helpers/functions/param';
import { AnyResponse } from 'services/API/common/Fetcher';
import axios, { defaultRequestHandler, getToken } from '../common/Fetcher';
import { GetBalanceCompanyResponse, GetBalanceCompanyTransactionResponse } from './interface';

export const getCompanyBalance = (company_id: string): Promise<GetBalanceCompanyResponse> =>
  defaultRequestHandler(
    axios.get(`/balance/${company_id}`, {
      headers: {
        authorization: getToken(),
      },
    }),
  );
export const getCompanyBalanceList = (company_id: string): Promise<GetBalanceCompanyResponse> =>
  defaultRequestHandler(
    axios.get(`/balance/${company_id}/balance-list`, {
      headers: {
        authorization: getToken(),
      },
    }),
  );
export const getCompanyBalanceTransaction = (
  company_id: string,
  data = {},
): Promise<GetBalanceCompanyTransactionResponse> =>
  defaultRequestHandler(
    axios.get(`/balance/${company_id}/transactions?${params(data)}`, {
      headers: {
        authorization: getToken(),
      },
      timeout: 60000,
    }),
  );
import { superOwner } from 'constants/Roles';

export const updateBalance = (role?: string): Promise<AnyResponse> => {
  const include =
    role === superOwner
      ? 'balance,daily_balance,company,companies,balance_info_list,daily_balance_list,companies.daily_balance_list'
      : 'balance,daily_balance,company,companies,balance_info_list,daily_balance_list';
  return defaultRequestHandler(
    axios.get(`me?include=${include}`, {
      headers: {
        authorization: getToken(),
      },
    }),
  );
};
